<template>
  <div class="clients-carousel" aria-label="Client logos">
    <div class="clients-track" :class="{ 'clients-track--animated': isPlaying }">
      <div class="clients-list">
        <span class="client-logo client-logo--amazon"><AmazonLogo /></span>
        <span class="client-logo"><HsbcLogo /></span>
        <span class="client-logo"><BarclaysLogo /></span>
        <span class="client-logo client-logo--db"><DeutscheLogo /></span>
        <span class="client-logo client-logo--rbc"><RbcLogo /></span>
      </div>
      <div v-if="isPlaying" class="clients-list" aria-hidden="true">
        <span class="client-logo client-logo--amazon"><AmazonLogo /></span>
        <span class="client-logo"><HsbcLogo /></span>
        <span class="client-logo"><BarclaysLogo /></span>
        <span class="client-logo"><DeutscheLogo /></span>
        <span class="client-logo"><RbcLogo /></span>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import AmazonLogo from "./logos/AmazonLogo.vue";
import HsbcLogo from "./logos/HsbcLogo.vue";
import BarclaysLogo from "./logos/BarclaysLogo.vue";
import DeutscheLogo from "./logos/DeutscheLogo.vue";
import RbcLogo from "./logos/RbcLogo.vue";

export default {
  name: "ClientsSection",
  components: {
    AmazonLogo,
    HsbcLogo,
    BarclaysLogo,
    DeutscheLogo,
    RbcLogo,
  },
  setup() {
    const isPlaying = ref(true);
    return { isPlaying };
  },
};
</script>

<style scoped>
.clients-carousel {
  width: 100%;
  overflow: hidden;
}

.clients-track {
  display: flex;
}

.clients-track--animated {
  width: max-content;
  animation: marquee 28s linear infinite;
}

.clients-track--animated:hover {
  animation-play-state: paused;
}

.clients-list {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  padding-right: 1.5rem;
}

.client-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 50px;
  flex-shrink: 0;
}

@media (min-width: 576px) {
  .client-logo {
    width: 85px;
  }
}

@media (min-width: 768px) {
  .clients-list {
    gap: 3rem;
    padding-right: 3rem;
  }

  .client-logo {
    width: 90px;
    height: 70px;
  }
}

@media (min-width: 1024px) {
  .client-logo {
    width: 100px;
  }
}

.client-logo :deep(svg) {
  width: 100%;
  height: 100%;
  object-fit: contain;
  color: var(--color-neutral-600);
  opacity: 0.75;
  transition: opacity 0.2s ease;
}

.client-logo:hover :deep(svg) {
  opacity: 1;
}

.client-logo--amazon {
  padding-top: var(--space-3);
}

.client-logo--rbc {
  width: 45px;
}

.client-logo--db {
  width: 110px;
  height: 50px;
}

@media (min-width: 768px) {
  .client-logo--db {
    width: 175px;
    height: 70px;
  }
  .client-logo--amazon {
    padding-top: var(--space-5);
  }
}

@keyframes marquee {
  0%   { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}

@media (min-width: 768px) {
  .clients-track--animated {
    animation: none;
    width: auto;
  }

  .clients-list[aria-hidden="true"] {
    display: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .clients-track--animated {
    animation: none;
  }
}
</style>
